import styled from 'styled-components';

export const Container = styled.div`
`;

export const FormFieldsRow = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  margin-bottom: 5px;
`;

export const FormApproveFieldsRow = styled.div`
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
`;

interface IFormFieldProps {
  marginLeft?: string;
  marginRight?: string;
}

export const FormField = styled.div<IFormFieldProps>`
  flex: 1;
  margin-bottom: 0px;
  margin-left: ${props => props.marginLeft || '0px'};
  margin-right: ${props => props.marginRight || '0px'};
`;